import fb from '@/services/firebase'
import { Timestamp, getDocs, updateDoc, doc, getDoc } from 'firebase/firestore'
import useDateFilter from '@/assets/lib/date_filter'
import useFirebaseQuery from '@/assets/lib/firebase_query'

export const namespaced = true

export const state = {
  customers: [],
  customer_loading: false
}

export const mutations = {
  SET_CUSTOMER(state, payload) {
    state.customers = payload
  },
  SET_CUSTOMER_LOADING(state, payload) {
    state.customer_loading = payload
  },
  UPDATE_CUSTOMERS(state, payload) {
    state.customers.forEach(item => {
      const businessFound = item.businesses.findIndex(eachBusiness => eachBusiness.business_id === payload.business_id)
      if (businessFound !== -1) {
        item.businesses[businessFound].business_name = payload.business_name
        item.businesses[businessFound].owner_id = payload.owner_id
        item.new_item = true
      }
    })
  }
}

export const actions = {
  async allCustomers({ commit, dispatch }, payload) {
    const date_filter = useDateFilter().dateFilter(payload)
    const start_date = Timestamp.fromDate(new Date(date_filter.start_date))
    const end_date = Timestamp.fromDate(new Date(date_filter.end_date))
    const num_of_days = Timestamp.fromDate(new Date(date_filter.num_of_days))

    let customers
    if (payload.period !== 'Between Dates') {
      customers = useFirebaseQuery().multiSimpleQuery(
        'dashboard_summary',
        'customers',
        'breakdown',
        'updated_at',
        num_of_days
      )
    } else {
      customers = useFirebaseQuery().multiComplexQuery(
        'dashboard_summary',
        'customers',
        'breakdown',
        'updated_at',
        start_date,
        end_date
      )
    }

    commit('SET_CUSTOMER', [])

    // const sales = query(
    //   collection(fb.db, 'dashboard_summary', 'customers', 'breakdown'),
    //   where('updated_at', '>=', new_date)
    // )
    const querySnapshot = await getDocs(customers)
    const container = []
    if (!querySnapshot.empty) {
      querySnapshot.forEach(snapDoc => {
        const details = snapDoc.data()
        details.id = snapDoc.id
        container.push(details)
        for (let index = 0; index < snapDoc.data().businesses.length; index++) {
          const business = snapDoc.data().businesses[index]
          if (business.business_name === undefined) {
            dispatch('getBusinessDetails', {
              business_id: business.business_id
            })
          }
        }
      })
      commit('SET_CUSTOMER', container)
    } else {
      commit('SET_CUSTOMER', container)
    }
  },
  async updateDashboardSummary({ state }) {
    state.customers.forEach(item => {
      if (item.new_item != undefined) {
        updateDoc(doc(fb.db, 'dashboard_summary', 'customers', 'breakdown', item.id), {
          businesses: item.businesses
        })
      }
    })
  },
  async getBusinessDetails({ commit }, payload) {
    const business_details = await getDoc(doc(fb.db, 'businesses', payload.business_id))
    commit('UPDATE_CUSTOMERS', {
      business_id: payload.business_id,
      business_name: business_details.data().business_name,
      owner_id: business_details.data().owner_id
    })
  }
}
